import React from "react";

const Analytics = () => {
    return (
        <>
            <iframe
                       height="100%"
                       style={{ width: "100%" }}
                       scrolling="no"
                       title="Iframe"
                       id="dashboardFrame"
                       src={
                         //getFormattedURL(dashboardURLConfig[domain]?.[activeKey]) ||
                         "https://analytics.zoho.in/open-view/103074000052557707/2b6cae1874e191734cf4d373e23b7481b966f0b2c2806e186c2e117161491b96"
                       }
             ></iframe>

            {/* <iframe
                       height="48%"
                       style={{ width: "100%" }}
                       scrolling="no"
                       title="Iframe"
                       id="dashboardFrame"
                       src={
                         //getFormattedURL(dashboardURLConfig[domain]?.[activeKey]) ||
                         "https://analytics.zoho.in/open-view/103074000052416711"
                       }
             ></iframe> */}
        </>
    )
};
export default Analytics;